import { Card, Col, Descriptions, Empty, Modal, Row, Space } from 'antd';
import { formatCurrency } from 'utils/number';

const OrderSnapshotModalDesktop = ({ open, title, onClose, viewModel }) => {
  const {
    snapshot,
    customerName,
    customerPhone,
    paymentTitle,
    shippingTitle,
    getLineItemName,
  } = viewModel;

  return (
    <Modal title={title} open={open} onCancel={onClose} footer={null} width={900}>
      {!snapshot ? (
        <Empty description='Không có dữ liệu snapshot' />
      ) : (
        <Space direction='vertical' size={16} style={{ width: '100%' }}>
          <Card size='small'>
            <Descriptions>
              <Descriptions.Item label='Mã đơn hàng'>{snapshot?.id || '-'}</Descriptions.Item>
              <Descriptions.Item label='Khách hàng'>{customerName}</Descriptions.Item>
              <Descriptions.Item label='SDT'>{customerPhone}</Descriptions.Item>
              <Descriptions.Item label='Thanh toán' span={3}>{paymentTitle}</Descriptions.Item>
              <Descriptions.Item label='Vận chuyển' span={3}>{shippingTitle}</Descriptions.Item>
              <Descriptions.Item label='Địa chỉ' span={3}>{snapshot?.shipping_address?.address || '-'}</Descriptions.Item>
              <Descriptions.Item label='Ghi chú' span={3}>{snapshot?.internal?.note || '-'}</Descriptions.Item>
            </Descriptions>
          </Card>

          <Row gutter={16}>
            <Col span={16}>
              <Card size='small'>
                <table className='tbl_order' style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th>Sản phẩm</th>
                      <th>Số lượng</th>
                      <th>Đơn giá</th>
                      <th>Thành tiền</th>
                    </tr>
                  </thead>
                  <tbody className='ant-table-tbody'>
                    {(snapshot?.line_items || []).map((line, index) => {
                      const quantity = Number(line?.quantity || 0);
                      const price = Number(line?.price || 0);
                      const amount = Number(line?.amount || (quantity * price));
                      return (
                        <tr key={`${line?.product_id || 'line'}-${index}`}>
                          <td>{getLineItemName(line)}</td>
                          <td>{quantity}</td>
                          <td style={{ textAlign: 'right' }}>{formatCurrency(price)}</td>
                          <td style={{ textAlign: 'right' }}>{formatCurrency(amount)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Card>
            </Col>
            <Col span={8}>
              <Card size='small'>
                <table className='tbl_order' style={{ width: '100%' }}>
                  <tbody className='ant-table-tbody'>
                    <tr>
                      <td>Tiền hàng</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.sub_amount || 0)}</td>
                    </tr>
                    <tr>
                      <td>Giảm giá</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.discount_amount || 0)}</td>
                    </tr>
                    <tr>
                      <td>Mã khuyến mãi</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.voucher_amount || 0)}</td>
                    </tr>
                    <tr>
                      <td>Xu</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.point_discount || 0)}</td>
                    </tr>
                    <tr>
                      <td>Phí ship</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.shipping_amount || 0)}</td>
                    </tr>
                    <tr>
                      <td>Tổng tiền</td>
                      <td style={{ textAlign: 'right' }}>{formatCurrency(snapshot?.total_amount || 0)}</td>
                    </tr>
                  </tbody>
                </table>
              </Card>
            </Col>
          </Row>
        </Space>
      )}
    </Modal>
  );
};

export default OrderSnapshotModalDesktop;